module.exports = __webpack_public_path__ + "b3f4d232c22d05cd83d8598ff251c8c4.glb";